import { render, staticRenderFns } from "./G-1-1b-4__SupportEdit_B2C_FAQ.vue?vue&type=template&id=d5ca4fb6&"
import script from "./G-1-1b-4__SupportEdit_B2C_FAQ.vue?vue&type=script&lang=js&"
export * from "./G-1-1b-4__SupportEdit_B2C_FAQ.vue?vue&type=script&lang=js&"
import style0 from "./G-1-1b-4__SupportEdit_B2C_FAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VIcon,VTextField})
